import { otGtmAlert } from "./utils/gtm-alert";
import { swiperLoader } from "./utils/swiper-loader";

// Recommended by Google: https://developer.chrome.com/docs/lighthouse/performance/third-party-facades#youtube_embedded_player
// import '../../node_modules/lite-youtube-embed/src/lite-yt-embed';

import { otSaasTabs } from "./components/saas-tabs.js"

import { otModals } from "./components/modal"
import { otTrialForm } from "./components/trial-form";

import { otAccordion } from "./patterns/SP07_1-accordion.js"
import { otCarouselCallouts } from "./patterns/SP06_1-carousel-callouts.js"
import { otFormMultistep } from  "./patterns/SP10_1-form_multistep" // Flowbite carousel
import { otMainNav } from "./patterns/SP00_2-main_nav.js"
import { otMainNavLegacy } from "./patterns/SP00_2-main-nav-legacy.js" // Flowbite collapse
import { otTabsVertical } from "./patterns/SP03_2-tabs-vertical.js" // Flowbite collapse
import { otVidyard } from "./patterns/SP05_3-vidyard"

const saasApi = {
    init() {
        // Get the path of the current script for usage in other scripts
        const currentScript = document.currentScript as HTMLScriptElement | null;
        const scriptSrc = currentScript?.src;
        const scriptPath = scriptSrc?.substring(0, scriptSrc.lastIndexOf("/")+1);

        document.addEventListener("DOMContentLoaded", () => {
            swiperLoader.init(scriptPath);
            otGtmAlert.init();

            // Components
            otModals.init();
            otSaasTabs.init();

            // Patterns
            otFormMultistep.init();
            otMainNav.init();
            otMainNavLegacy.init();
            otCarouselCallouts.init();
            otTabsVertical.init();
            otAccordion.init();
            otTrialForm.init();
            otVidyard.init();
        });
    }
}

declare global {
  interface Window {
    saasApi: typeof saasApi;
  }
}

(window as any).saasApi = saasApi;

window.saasApi.init();
